"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TextInputComponent.default;
  }
});

var _TextInputComponent = _interopRequireDefault(require("./TextInput-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }